// extracted by mini-css-extract-plugin
export default {"progressBarWrapper":"Usage_progressBarWrapper__p8C1-","progressBar":"Usage_progressBar__RJcrN","legend":"Usage_legend__0KbOb","link":"Usage_link__cF8JW"};